import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import authActions from '@/redux/auth/actions';
import GlobalHeader from './GlobalHeader';

const mapStateToProps = ({ auth }) => ({ auth });

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      signOut: authActions.signOut,
      saveSupportInfo: authActions.saveSupportInfo,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(GlobalHeader);
